import tw from 'tailwind-styled-components'

export const minContainerWidth = 400
export const OneLineHeight = 24
export const PanelPaddingX = 8
export const StickersPaddingY = 4
export const StickersGapX = 2
export const StickersGapY = 4
export const MinStickerPanelWidth = 240

export const TwStickerPanelWrapper = tw.div`
  w-full
  min-h-32
`

export const TwStickerPanel = tw.div`
  w-fit
  flex
  bg-background-sticker-panel
  border-0
  border-solid
  border-transparent
  rounded-8
  relative
  z-20
  
  ${() => `
    px-${PanelPaddingX}
  `}
`

export const TwLeftArea = tw.div<{$isEditAvailable: boolean}>`
  flex
  items-center
  mt-4
  h-24
  ${p => (p.$isEditAvailable ? 'mr-8' : '')}
`

export const TwStickers = tw.div`
  //transition-[height]
  flex
  flex-wrap
  content-start
  overflow-hidden
  
  ${() => `
    py-${StickersPaddingY}
  `}
`

export const TwRightArea = tw.div`
  flex
  gap-8
  items-center
  h-[32px]
`

export const TwCollapseButton = tw.div<{$short: boolean}>`
  group
  flex
  gap-4
  h-[22px]
  items-center
  pr-4
  bg-primary
  cursor-pointer
  outline
  outline-1
  outline-sticker-panel
  
  ${({$short}) =>
    $short ? 'pl-6 rounded-l-[8px] rounded-r-[12px]' : 'pl-4 rounded-[8px]'}
`

export const TwHiddenStickersCount = tw.div<{$filtersInHiddenArea: boolean}>`
  min-w-16
  px-2
  text-center
  text-11
  border-1
  border-transparent
  rounded-full
  
  ${({$filtersInHiddenArea}) =>
    $filtersInHiddenArea
      ? 'text-icon-invert bg-action-default'
      : 'text-grey bg-background-secondary'}
`
